import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import { useLogin } from '../../store/backend/uselogin';
import useAuth from '../../hooks/useAuth';
import PrimaryButton from '../../widgets/Button/PrimaryButton/PrimaryButton';
import routes from '../../constants/routes';

import './LoginContainer.css';

const handleOnSuccessLogin = (data, authLogin, navigate, setPhoneNumber, setAdmissionNumber) => {
    authLogin(data.accessToken);
    setPhoneNumber(data.phoneNumber);
    setAdmissionNumber(data.admission_number);
    localStorage.setItem('phoneNumber', data.phoneNumber);
    localStorage.setItem('admissionNumber', data.admission_number);
    localStorage.setItem("user_id", data.crnId);
    navigate(routes.SearchUser);
};

const LoginContainer = ({ setPhoneNumber, setAdmissionNumber }) => {
    const navigate = useNavigate();
    const { login: authLogin } = useAuth();

    const { mutate: login, isLoading, isError, error } = useLogin(
        (data) => handleOnSuccessLogin(data, authLogin, navigate, setPhoneNumber, setAdmissionNumber),
    );

    const formik = useFormik({
        initialValues: {
            phoneNumber: '',
            password: '',
        },
        validationSchema: Yup.object({
            phoneNumber: Yup.string().required('Phone number is required'),
            password: Yup.string().required('Password is required'),
        }),
        onSubmit: (values) => {
            login(values);
        },
    });

    return (
        <div className="login-container">
            <div className="login-box">
                <form onSubmit={formik.handleSubmit}>
                    <h1 className="login-title">Login</h1>
                    <p className="login-hint">Sign in with your phone number.</p>

                    <input
                        id="phoneNumber"
                        type="tel"
                        name="phoneNumber"
                        autoComplete="tel"
                        value={formik.values.phoneNumber}
                        placeholder="Phone number"
                        className="form-control"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                    />
                    {formik.touched.phoneNumber && formik.errors.phoneNumber && (
                        <p className="error">{formik.errors.phoneNumber}</p>
                    )}

                    <input
                        className="form-control"
                        type="password"
                        placeholder="Enter password"
                        name="password"
                        value={formik.values.password}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                    />
                    {formik.touched.password && formik.errors.password && (
                        <p className="error">{formik.errors.password}</p>
                    )}

                    {isError && (
                        <p className="login-error-message">
                            {error.message || 'Something went wrong'}
                        </p>
                    )}

                    <div className="login-button-container">
                        <PrimaryButton type="submit" disabled={isLoading}>
                            {isLoading ? <div className="loader" /> : 'Login'}
                        </PrimaryButton>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default LoginContainer;
